import React from 'react';
import './SloganDifferent.css';
import iconRelationships from './images/HPP_Relationship_Icon.svg';
import iconCollaboration from './images/HPP_Collaboration_Icon.svg';
import iconExecution from './images/HPP_Execution_Icon.svg';
import iconOpportunity from './images/HPP_Opportunity_Icon.svg';
import iconIntegrity from './images/HPP_Integrity_Icon.svg';
import iconInnovation from './images/HPP_Innovation_Icon.svg';

// @TODO: hard coded content which will need to be refactored for CMS integration
const SloganDifferent = () => {
    return (
        <section className="slogan-section">
            <div className="bg-holder">
                <div className="container">
                    <div className="columns">
                        <div className="column is-11-mobile is-11-tablet is-9-desktop is-8-widescreen slogan-main-column">
                            <div className="slogan-block-wrapper">
                                <div className="container">
                                    <div className="columns">
                                        <div className="column">
                                            <div className="title-wrapper animated fadeInLeft">
                                                <div className="title">
                                                    &ldquo;Now more than ever, individuals desire a values-based culture in their place of work.&rdquo;
                                                </div>
                                                <div className="slogan-footer">
                                                    <div className="author">
                                                    Lisa Burelli
                                                    </div>
                                                    <div className="job">
                                                    Chief People Officer
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="section differentiators-section">
                <div className="container">
                    <div className="columns">
                        <div className="column is-12-mobile is-10-tablet is-offset-1-tablet is-10-desktop is-10-widescreen">
                            <div className="differentiators-block-wrapper">
                                <div className="columns">
                                    <div className="column">
                                        <div className="title-wrapper animated fadeInLeft">
                                            <div className="pre-title">Differentiators</div>
                                            <div className="big-title">
                                                What sets us apart
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="icons-wrapper">
                                    <div className="columns is-half-tablet">
                                        <div className="column">
                                            <div className="icon-box-1 iconix icon-relationships">
                                                <img src={iconRelationships} alt={iconRelationships} width="58" height="58"/>
                                            </div>
                                            <div className="status">
                                            Relationships
                                            </div>
                                            <div className="bodyCopy">
                                            Our industry relationships are built on a foundation of trust and loyalty&mdash;
                                            we create lasting partnerships.
                                            </div>
                                        </div>
                                        <div className="column">
                                            <div className="icon-box-2 iconix icon-execution">
                                                <img src={iconExecution} alt={iconExecution} width="62" height="51"/>
                                            </div>
                                            <div className="status">
                                            Execution
                                            </div>
                                            <div className="bodyCopy">
                                            We work at the highest level to accomplish our objectives. We fire on all cylinders,
                                            even in the face of challenge and change.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="columns is-half-tablet">
                                        <div className="column">
                                            <div className="icon-box-3 iconix icon-opportunity">
                                                <img src={iconOpportunity} alt={iconOpportunity} width="62" height="58"/>
                                            </div>
                                            <div className="status">
                                            Opportunity
                                            </div>
                                            <div className="bodyCopy">
                                            Our relationships give us unparalleled access to opportunities, while our skills
                                            and vision enable us to realize a property&#39;s full potential.
                                            </div>
                                        </div>
                                        <div className="column">
                                            <div className="icon-box-4 iconix icon-integrity">
                                                <img src={iconIntegrity} alt={iconIntegrity} width="48" height="58"/>
                                            </div>
                                            <div className="status">
                                            Integrity
                                            </div>
                                            <div className="bodyCopy">
                                            We operate with incomparable integrity, always mindful our stakeholders&#39; interests
                                            and our fiduciary responsibilities.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="columns is-half-tablet">
                                        <div className="column">
                                            <div className="icon-box-5 iconix icon-collaboration">
                                                <img src={iconCollaboration} alt={iconCollaboration} width="73" height="62"/>
                                            </div>
                                            <div className="status">
                                            Collaboration
                                            </div>
                                            <div className="bodyCopy">
                                            Our truly collaborative process allows us to reach solutions that exceed expectations,
                                            while learning and growing together.
                                            </div>
                                        </div>
                                        <div className="column">
                                            <div className="icon-box-6 iconix icon-innovation">
                                                <img src={iconInnovation} alt={iconInnovation} width="53" height="62"/>
                                            </div>
                                            <div className="status">
                                            Innovation
                                            </div>
                                            <div className="bodyCopy">
                                            Our forward-thinking approach enables us to partner with some of the world&#39;s
                                            most revolutionary companies.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </section>
    );
};

export default SloganDifferent;
